const Accordion = ({ controllerElement, expanded, onChange, children }: any) => {
  return (
    <>
      <div onClick={() => onChange((prevIsExpanded: boolean) => !prevIsExpanded)}>{controllerElement(expanded)}</div>
      {expanded && <div>{children}</div>}
    </>
  );
};

export default Accordion;
